import { useCallback } from 'react'

import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import { isB2BView } from '@app/utils'

import { Avatar, Icon } from '@lib/components'

import { getParticipantSubtitle } from './helpers'
import styles from './styles.module.scss'
import { ParticipantItemProps } from '../Participants/types'

export const ParticipantItem = ({
  participantItem,
  onClick,
  isCurrentUserPrivateAdvertiser,
}: ParticipantItemProps) => {
  const {
    avatar,
    fullName,
    jobTitle,
    isSubtitleReady,
    isCurrentUser,
    isB2CParticipant,
    isPrivateAdvertiser,
    labels = [],
    shouldFallbackToAccount,
  } = participantItem
  const { t } = useTranslation()

  const isNonInteractiveParticipant =
    isCurrentUser ||
    (isCurrentUserPrivateAdvertiser && isB2CParticipant) ||
    (!isB2BView() && Boolean(isPrivateAdvertiser))

  const wrapperClassName = classNames(styles.participantWrapper, {
    [styles.firstOrder]: isCurrentUser,
    [styles.nonInteractive]: isNonInteractiveParticipant,
  })

  const subtitle = isSubtitleReady
    ? getParticipantSubtitle(labels, jobTitle, t)
    : ''

  const handleClick = useCallback(() => {
    if (!isNonInteractiveParticipant) {
      onClick(participantItem)
    }
  }, [isNonInteractiveParticipant, onClick, participantItem])

  return (
    <div className={wrapperClassName} onClick={handleClick}>
      <div className={styles.avatar}>
        <Avatar
          avatar={avatar}
          fullName={fullName}
          size="regular"
          template={shouldFallbackToAccount ? 'logo-sm' : 'user-sm'}
        />
      </div>
      <div className={styles.participantDetails}>
        <div className={styles.fullName}>{fullName}</div>
        {isSubtitleReady && (
          <div className={styles.subtitle}>{subtitle}</div>
        )}
      </div>
      {!isNonInteractiveParticipant && (
        <div className={styles.action}>
          <Icon path="icons/icon-arrow-right" />
        </div>
      )}
    </div>
  )
}
